import React, { useRef, useEffect, useState } from 'react';
import { animate } from 'animejs';
import { useLanguage } from '../context/LanguageContext';
import './Stats.css';

// Edita estos números según los datos reales
const STATS = [
  { value: 5000, suffix: '+', key: 'trips' },
  { value: 1200, suffix: '+', key: 'clients' },
  { value: 8, suffix: '', key: 'years' },
];

function Stats() {
  const { t } = useLanguage();
  const sectionRef = useRef(null);
  const [displayValues, setDisplayValues] = useState(STATS.map(() => 0));
  const animatedRef = useRef(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section || animatedRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        animatedRef.current = true;
        const items = section.querySelectorAll('.stat-item');
        items.forEach((el, i) => {
          animate(el, { opacity: [0, 1], y: [16, 0], duration: 500, delay: i * 100, ease: 'outExpo' });
        });
        STATS.forEach((stat, i) => {
          const duration = 1500;
          const delay = i * 150;
          const startTime = performance.now() + delay;
          const tick = (now) => {
            const elapsed = Math.min(Math.max((now - startTime) / duration, 0), 1);
            const eased = 1 - Math.pow(2, -10 * elapsed);
            const val = Math.round(stat.value * eased);
            setDisplayValues((prev) => {
              const next = [...prev];
              next[i] = val;
              return next;
            });
            if (elapsed < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        });
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.2 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="stats" aria-labelledby="stats-title">
      <h2 id="stats-title" className="visually-hidden">
        {t('stats.title')}
      </h2>
      <div className="stats-grid">
        {STATS.map((stat, i) => (
          <div key={stat.key} className="stat-item">
            <span className="stat-number" aria-hidden="true">
              {displayValues[i].toLocaleString()}
              {stat.suffix}
            </span>
            <span className="stat-label">{t(`stats.${stat.key}`)}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Stats;
